export default {
  getCmsInfo: "cmsInfo/getCmsInfo",
  cmsInfoPage: "cmsInfo/cmsInfoPage",
  getTypeNameList: "cmsInfo/getTypeNameList",
  menuTreeData: "cmsMenu/menuTreeData",
  updateCount:"cmsInfo/cmsCountAdd"

}
